var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Package",
    transform: "translate(-1926 -463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4021",
    "data-name": "Rectangle 4021",
    width: 60,
    height: 60,
    transform: "translate(1926 463)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M7.774,17.675H26.822V6.891H15.312a2.4,2.4,0,0,0-2.178,1.263Zm21.538,0H48.533L44.141,8.316a2.419,2.419,0,0,0-2.263-1.423l-12.567,0Zm22.254.616.17.629V46.658a5.091,5.091,0,0,1-5.079,5.079H9.477A5.091,5.091,0,0,1,4.4,46.658V18.92a1.241,1.241,0,0,1,.2-.671l6.37-11.312A4.91,4.91,0,0,1,15.312,4.4H41.881a4.917,4.917,0,0,1,4.511,2.863Zm-2.322,1.873H6.889V46.656a2.6,2.6,0,0,0,2.587,2.587H46.655a2.6,2.6,0,0,0,2.587-2.587Z",
    transform: "translate(1927.602 464.601)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.ba1ae7d41b08d9bba989abec79891a2e.svg";
export { ForwardRef as ReactComponent };